import React from 'react'
import moment from 'moment'
import { SelectField } from '@adc/ui-core'

const YEARS_OPTIONS_COUNT = 10

const getYears = () => {
  const current = moment()
  const years = []
  for (let i = 1; i <= YEARS_OPTIONS_COUNT; i++) {
    const yearFormat = current.format('YYYY')
    years.push({ key: yearFormat, value: yearFormat, text: yearFormat })
    current.add(1, 'years')
  }
  return years
}

const YEARS = getYears()

const Year = props => {
  return (
    <SelectField
      autoComplete='cc-exp-year'
      label='Year'
      options={YEARS}
      {...props}
    />
  )
}

export default Year
